enum MutationType {
  QUERY_DATA_COLLECTION_SUCCEED = "top50/QUERY_DATA_COLLECTION_SUCCEED",
  QUERY_DATA_COLLECTION_START = "top50/QUERY_DATA_COLLECTION_START",
  QUERY_DATA_COLLECTION_FAIL = "top50/QUERY_DATA_COLLECTION_FAIL",
}

export default MutationType;
